// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"08f49ca9","189":"1f59b18d","194":"4535b1d4","380":"ba647682","411":"227c6ac0","656":"8105d409","720":"79ad21f7","843":"f1d9439d","933":"64e46986","974":"674df9a1"}[chunkId] + ".chunk.js";
};